import React, { useState, useEffect, useContext, useRef } from 'react'
// import SignUp from './Signup/SignUp'
import Popup from './Popup/Popup'
import Nav from './Nav/Nav'
import OverlayNav from './OverlayNav/OverlayNav'
import CountySelector from './CountySelector/CountySelector'
import * as HeaderStyles from './Header.module.scss'
import * as NavStyles from './Nav/Nav.module.scss'
import Social from '../Social/Social'
import SaveIcon from '../../assets/love-heart.svg'
import Search from '../../assets/search.svg'
import SearchOverlay from './Search/Search'
import { Link, navigate } from 'gatsby'
import moment from 'moment'
// eslint-disable-next-line node/no-extraneous-import
// import { useQuery } from '@apollo/client'
import { fixAmpersands, LoginContext, headerEvents } from '../../lib/utils'
import NewNav from './Nav/NewNav'
interface HeaderProps {
  siteId?: number | null
  siteName?: string | null
}

const Header = ({ siteId, siteName }: HeaderProps) => {
  const [navVisibility, setNavVisibility] = useState<boolean>(false)
  const [countyVisibility, setCountyVisibility] = useState<boolean>(false)
  const [searchVisibility, setSearchVisibility] = useState<boolean>(false)
  const [sticky, setSticky] = useState<string>('')
  const [logoutText, setLogoutText] = useState<string>('Log Out')
  const { usr: data, setUsr: setUser } = useContext(LoginContext)
  const [popup, setPopup] = React.useState<boolean>(false)
  const [popupShown, setPopupShown] = useState<boolean>(false)
  const [isInteracting, setIsInteracting] = useState<boolean>(false)
  const [navState, setNavState] = useState<'full' | 'collapsed' | 'hidden'>(
    'full'
  )
  const HeaderRef = useRef<HTMLDivElement>(null)
  const [lastScrollPos, setLastScrollPos] = useState<number>(0)

  useEffect(() => {
    if (HeaderRef?.current) {
      const resizeObserver = new ResizeObserver(() => {
        const newHeight = HeaderRef.current?.getBoundingClientRect().height
        headerEvents.emit('heightChanged', newHeight)
      })

      resizeObserver.observe(HeaderRef.current)

      return () => {
        resizeObserver.disconnect()
      }
    }
  }, [HeaderRef])

  const toggleMenu = () => {
    setNavVisibility(!navVisibility)
  }

  const handleLogout = () => {
    setLogoutText('Logging out...')
    try {
      localStorage.removeItem('token')
      setTimeout(() => {
        setUser && setUser({})
        setLogoutText('Log Out')
        const route =
          typeof window !== 'undefined' ? window.location.pathname : ''
        if (route === '/dashboard/') {
          navigate('/log-in/')
        }
      }, 1000)
    } catch (e) {
      console.log(e)
    }
  }

  const popupDismissedStatus = () => {
    const dismissedToken = localStorage.getItem('popupDismissed')
    if (!dismissedToken) return false
    const tokenDate = moment(dismissedToken, 'YYYYMMDDHHmmss')
    const now = moment()
    const diff = now.diff(tokenDate, 'days')
    if (diff < 3) return true

    return false
  }

  useEffect(() => {
    setTimeout(() => {
      !data?.viewer && !popupDismissedStatus() && setPopup(true)
    }, 15000)
  }, [])

  useEffect(() => {
    if (!popup && popupShown) {
      const today = moment().format('YYYYMMDDHHmmss')
      localStorage.setItem('popupDismissed', today)
    } else if (popup && !popupShown) {
      setPopupShown(true)
    }
  }, [popup])

  const isSticky = () => {
    const scrollTop = window.scrollY
    const stickyClass = scrollTop >= 210 ? HeaderStyles.isFloating : ''
    const direction = scrollTop > lastScrollPos ? 'down' : 'up'
    let newState: 'full' | 'collapsed' | 'hidden' = 'full'

    if (!isInteracting) {
      if (scrollTop > 1000) {
        if (direction === 'up') {
          newState = 'collapsed'
        } else {
          newState = 'hidden'
        }
      } else if (scrollTop > 210 && scrollTop < 1000) {
        if (direction === 'up') {
          newState = 'full'
        } else {
          newState = 'collapsed'
        }
      }
    } else {
      newState = 'full'
    }

    if (navState !== newState) {
      setNavState(newState) // Update the component's state
      headerEvents.emit('headerState', newState) // Emit event
    }
    setSticky(stickyClass)
    setLastScrollPos(scrollTop)
  }

  useEffect(() => {
    if (isInteracting) {
      setNavState('full')
    }

    window.addEventListener('scroll', isSticky)

    return () => {
      window.removeEventListener('scroll', isSticky)
    }
  }, [navState, lastScrollPos, isInteracting])

  // When the user stops interacting with the NavBar
  const handleMouseLeave = () => {
    setIsInteracting(false)
  }

  return (
    <header
      className={`${HeaderStyles.Base} ${sticky}`}
      // onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* {!data?.viewer && <SignUp />} */}

      {popup && <Popup siteId={siteId ?? 1} setPopup={setPopup} />}

      <div
        ref={HeaderRef}
        data-state={navState}
        className={HeaderStyles.Wrapper}
      >
        <div className={HeaderStyles.InnerWrapper}>
          <div
            className={`${HeaderStyles.BurgerMenu} ${
              navVisibility ? HeaderStyles.IsActive : ''
            }`}
            onClick={() => toggleMenu()}
            tabIndex={0}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className={HeaderStyles.CountyLinks}>
            <span
              onClick={() => setCountyVisibility(true)}
              className={HeaderStyles.CountyIdentifier}
            >
              {siteId && siteId > 1
                ? fixAmpersands(siteName ?? '')
                : 'Select county'}
            </span>
          </div>
          <div className={HeaderStyles.Logo}>
            <Link to={`/`}>Muddy Stilettos</Link>
          </div>
          <div className={HeaderStyles.PrimaryLinks}>
            <div>
              {!data?.viewer ? (
                <Link to={`/sign-up`}>Sign up</Link>
              ) : (
                <Link to={`/dashboard`}>Muddy Account</Link>
              )}

              <span>|</span>
              {data?.viewer ? (
                <span onClick={handleLogout}>{logoutText}</span>
              ) : (
                <Link to={`/log-in`}>Log in</Link>
              )}
              <Link to={`/favourites`}>
                <img src={SaveIcon} alt="Save" />
              </Link>
              <span onClick={() => setSearchVisibility(true)}>
                <img src={Search} alt="Search" />
              </span>
            </div>
            <div className={HeaderStyles.SocialLinks}>
              <span className={NavStyles.SocialLinks}>
                <Social />
              </span>
            </div>
          </div>
        </div>
        <NewNav />
        {navState === 'full' && <Nav />}
        {/* <Nav /> */}
        <hr />
        <OverlayNav
          visibility={navVisibility}
          siteName={siteName}
          siteId={siteId}
          setSearchVisibility={setSearchVisibility}
        />
        <SearchOverlay
          visibility={searchVisibility}
          onClose={() => setSearchVisibility(false)}
        />
        <CountySelector
          isOpen={countyVisibility}
          onClose={() => setCountyVisibility(false)}
        />
      </div>
    </header>
  )
}

export default Header
